import { Component, Input, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { ComputeService } from '../services/compute.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { ActivatedRoute, Params } from '@angular/router';
import { VcaGrid } from '../../../../../common/vca-grid/vca-grid.component';

@Component({
  selector: 'vapp-grid',
  providers: [
    ComputeService, TranslateService
  ],
  template: `
  <div style="margin-top:20px;"
    *ngIf="loadVappGrid"
    [vcaGrid]=tableSettings
    [gridData]=vappList
    (onSelectionChange)="onGridSelectionChange($event);"
    class="crudGrid">
  </div>`
})

export default class VAppGrid {
    vappList: any;
    vdcId: string = '01757473-6bcc-4e6a-a386-4c918edeb8db';
    loadVappGrid: boolean = false;
    private tableConfig: Object = {};
    private tableSettings: Object = {};
    constructor(public computeService: ComputeService,
        private translateService: TranslateService, private route: ActivatedRoute) {
    translateService.use(GlobalVariables.LOCALE);
    }

    ngOnInit() {
        this.tableConfig = this.getVappsListTableConfig();
        (<any>Object).assign(this.tableSettings, this.tableConfig, {'data': []});
        this.computeService.getVappList(this.vdcId)
        .subscribe(
            res => { this.vappList = res[0].vapps;
            this.loadVappGrid = true;
            }
        );
    }

    getVappsListTableConfig() {
    return {
        columns: [
            {'data': 'vcd.name',
             'width': '50%',
             'title': this.translateService.instant('vApp Name')},
            {'data': 'vcd.vdcId',
             'width': '50%',
             'title': this.translateService.instant('VDC ID')}
        ],
        enableRowDetails: true,
        detailsControlClass: 'details-control',
        paging: false,
        'autoWidth': true,
        scrollY: '60vh'
    };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/vapp-grid/vapp-grid.component.ts